import { VisibilityType } from '../constants'
import { SelectOption } from '../model/SelectOption'

export const VISIBILITY_FILTER_SELECT_VALUES: SelectOption<string>[] = [
  { value: VisibilityType.ALL, label: 'Tous' },
  { value: VisibilityType.PUBLIC, label: 'Publics' },
  { value: VisibilityType.PRIVATE, label: 'Privés' },
]
